import { isHmBrand, consoleEvents, isAppDevice, isNorthstarBrand } from '@pb/utils'

export default function updateMiniCart(cartItems?: Array<any>): any {
  try {
    if (cartItems !== undefined && !(isHmBrand || isNorthstarBrand)) {
      const totalQtyItems = cartItems
        .map((item) => item.quantity)
        .reduce((tot, quantity) => {
          return tot + quantity
        }, 0)

      const quantitySpan = document.querySelector('.o-bag span.count')
      if (quantitySpan !== null) {
        quantitySpan.innerHTML = totalQtyItems
      }
    } else {
      window.hm.cookies?.setupUser()
      if (isAppDevice()) {
        window.location.href = 'hm://refreshcartcount'
      } else {
        if (!window) return
        try {
          const event = new Event('CART_UPDATE_EVENT')
          window.dispatchEvent(event)
        } catch (e) {
          consoleEvents.error('custom event dispatch failed', e)
        }
      }
    }
  } catch (e) {
    consoleEvents.error('Error when updating mini cart', e)
  }
}
